/**
 * Arabic text as a search compares it. A person typing Arabic does not type the hamza, the ta
 * marbuta or the alef maqsura the way the record was written, so «احمد» has to find «أحمد»,
 * «مؤسسه» «مؤسسة», and «علي» «على». Both sides are folded the same way: the hamza forms of alef
 * read as alef, hamza on waw and on ya as their letter, ta marbuta as ha, alef maqsura as ya,
 * tashkeel and tatweel dropped, Arabic-Indic and Persian digits read as digits, then lower case.
 * Used by the list search, the advanced filter's text comparisons, the lookup and the import's
 * header matching — one rule, so a word found in one place is found in all of them.
 */
export function foldArabic(text) {
    return text
        .normalize('NFC')
        // The isolates that keep a code in its order (i18n's `isolate`) are not letters to match.
        .replace(/[\u2066-\u2069]/g, '')
        .replace(/[ً-ْٰـ]/g, '')
        .replace(/[أإآٱ]/g, 'ا')
        .replace(/ؤ/g, 'و')
        .replace(/ئ/g, 'ي')
        .replace(/ة/g, 'ه')
        .replace(/ى/g, 'ي')
        .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
        .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06F0))
        .toLocaleLowerCase();
}
//# sourceMappingURL=arabic.js.map